'use client';
import { Button } from '@common/components';
import { SvgShare2 } from '@common/icon';
import { useQuery } from '@tanstack/react-query';

import { AuthQueryOptions } from '@/api';
import { CustomLink } from '@/app/_components/CustomLink';
import { openShareDrawer } from '@/app/_components/GlobalModal/_components/ShareDrawer';
import { DONATION_ROUTES } from '@/constants';
import { useAuthStore } from '@/stores/AuthStore';
import { checkTodayInRange, getNowInKorea } from '@/utils/checkTodayInRange';

import { EVENT_INFO } from '../constants';
import { COMPLETED_DONATION_COUNT } from './StampMapSection/constants';

export const FloatingCtaButton = () => {
  const isLogin = useAuthStore((state) => state.isLogin);

  const { data: localTourData } = useQuery({
    ...AuthQueryOptions['get:/wello/v2/auth/home-donation/event/local-tour'](),
    enabled: isLogin,
    select: ({ context }) => context,
  });

  const donationCount = localTourData?.donationCount ?? 0;
  const disabledButton =
    isLogin === undefined ||
    donationCount >= COMPLETED_DONATION_COUNT ||
    !checkTodayInRange(
      EVENT_INFO.START_DATE.toDate(),
      EVENT_INFO.END_DATE.toDate(),
    ) ||
    EVENT_INFO.START_DATE.isAfter(getNowInKorea());
  const buttonText = (() => {
    if (isLogin === undefined) return '-';
    if (EVENT_INFO.START_DATE.isAfter(getNowInKorea()))
      return `${EVENT_INFO.START_DATE.format('YYYY-MM-DD')} 오픈 예정`;
    if (
      !checkTodayInRange(
        EVENT_INFO.START_DATE.toDate(),
        EVENT_INFO.END_DATE.toDate(),
      )
    )
      return '마감';

    if (donationCount >= COMPLETED_DONATION_COUNT) return '기부 완료';
    if (donationCount > 0) return '답례품 더 받기';

    return '기부하러 가기';
  })();

  return (
    <div className="sticky bottom-0 bg-Gray-white/50 px-20 py-12 backdrop-blur-sm flex-center">
      <div className="flex w-full max-w-[44.375rem] items-center gap-16">
        <Button
          theme="primary-fill"
          dimensions="H56"
          asChild
          disabled={disabledButton}
          className="w-full"
        >
          <CustomLink
            href={`${DONATION_ROUTES.HOME.pathname}?utm_source=wello&utm_medium=event&utm_campaign=event_1106&utm_content=donation_251106`}
            aria-label="웰로 고향사랑기부 홈으로 이동"
            onClick={(e) => {
              if (disabledButton) {
                e.preventDefault();

                return;
              }
            }}
          >
            {buttonText}
          </CustomLink>
        </Button>
        <button
          type="button"
          aria-label="공유하기"
          className="size-fit p-0"
          onClick={() => {
            openShareDrawer(location.href);
          }}
        >
          <SvgShare2 className="size-20 text-Gray-black" originalFill />
        </button>
      </div>
    </div>
  );
};
